module.exports = __webpack_public_path__ + "img/check-blue.de00bff6.svg";